// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}

.searchbarUser {
  position: relative;
}

.searchbarUser .MuiOutlinedInput-input {
  padding: 10px 14px;
  position: relative;
  width: 235px;
  white-space: nowrap;
  overflow: hidden !important;
  text-overflow: ellipsis;
  padding-right: 51px;
  outline: none !important;
}

.searchbarUser .btn-primary:hover {
 
  border-left: 1px solid #d2d2d2;
}
.searchbarUser .btn-primary {
  position: absolute;
  border: none;
  outline: none;
  right: 1px;
  top: 2px;
  background: #f8f8f8;
  border-left: 1px solid #d2d2d2;
  border-radius: 2px;
}
.searchbarUser .btn-primary:hover { 
   background-color: transparent;
}
.searchbarUser  fieldset {
  top: 0px;
}
.searchbarUser fieldset.PrivateNotchedOutline-root-1.MuiOutlinedInput-notchedOutline:focus-visible {
  border-color: rgba(0, 0, 0, 0.23);
}

.searchbarUser .MuiOutlinedInput-root {
    outline: none;
}
.downloadbtnsingle{
display: flex;
align-items: center;
justify-content: center;
}


.getStartBtn{
  transition: all .3s ease;
  position: relative;
  z-index: 1;
  padding: 9px 18px;
  cursor: pointer;
  font-weight: 300;
  font-size: 14px;
  border-radius: 6px;
  outline: none !important;
  line-height: normal;
  color: #fff;
  display: inline-block;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE;aACW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;;EAEE,8BAA8B;AAChC;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,UAAU;EACV,QAAQ;EACR,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;AACpB;AACA;GACG,6BAA6B;AAChC;AACA;EACE,QAAQ;AACV;AACA;EACE,iCAAiC;AACnC;;AAEA;IACI,aAAa;AACjB;AACA;AACA,aAAa;AACb,mBAAmB;AACnB,uBAAuB;AACvB;;;AAGA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,UAAU;EACV,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,wBAAwB;EACxB,mBAAmB;EACnB,WAAW;EACX,qBAAqB;AACvB","sourcesContent":["body {\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n}\n\n.searchbarUser {\n  position: relative;\n}\n\n.searchbarUser .MuiOutlinedInput-input {\n  padding: 10px 14px;\n  position: relative;\n  width: 235px;\n  white-space: nowrap;\n  overflow: hidden !important;\n  text-overflow: ellipsis;\n  padding-right: 51px;\n  outline: none !important;\n}\n\n.searchbarUser .btn-primary:hover {\n \n  border-left: 1px solid #d2d2d2;\n}\n.searchbarUser .btn-primary {\n  position: absolute;\n  border: none;\n  outline: none;\n  right: 1px;\n  top: 2px;\n  background: #f8f8f8;\n  border-left: 1px solid #d2d2d2;\n  border-radius: 2px;\n}\n.searchbarUser .btn-primary:hover { \n   background-color: transparent;\n}\n.searchbarUser  fieldset {\n  top: 0px;\n}\n.searchbarUser fieldset.PrivateNotchedOutline-root-1.MuiOutlinedInput-notchedOutline:focus-visible {\n  border-color: rgba(0, 0, 0, 0.23);\n}\n\n.searchbarUser .MuiOutlinedInput-root {\n    outline: none;\n}\n.downloadbtnsingle{\ndisplay: flex;\nalign-items: center;\njustify-content: center;\n}\n\n\n.getStartBtn{\n  transition: all .3s ease;\n  position: relative;\n  z-index: 1;\n  padding: 9px 18px;\n  cursor: pointer;\n  font-weight: 300;\n  font-size: 14px;\n  border-radius: 6px;\n  outline: none !important;\n  line-height: normal;\n  color: #fff;\n  display: inline-block;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
